import React from 'react';
import { Modal } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import {RequestStatus} from '../../../common/const/RequestStatus'
import { LabelText } from '../../../components/Language';
import './CustomModal.css';

const inProgressOrSuccessBody = (props) =>{
return (
    <div className= "Bulk-processing-body">
        <div className="Status-label">{props.Status === RequestStatus.Inprogress.id ? <LabelText tid={RequestStatus.Inprogress.value} />
            : (props.Status === RequestStatus.Success.id || props.Status === RequestStatus.SuccessCr.id) ? props.isWeekly ? <LabelText tid="revenuebulksuccess" />
            : props.isDailyReceiptJournal ? <LabelText tid="dailyreceiptbulksuccess" />
                : <LabelText tid={RequestStatus.Success.value} /> : ""}</div>
        <div>
        <div className = "notifyContainer" > 
        {props.isMonthlyRevenueSubmitted && <div className = "notifyImage"></div> }       
        </div>
        <div className="notifyData">
        <div>{props.isMonthlyRevenueSubmitted && <span className="Bulk_saved-success-message">{<LabelText tid={props.selectedAttentionMessage} />}</span>}</div>
        <div>{props.isMonthlyRevenueSubmitted && <span className="Bulk_saved-success-message">{<LabelText tid={props.selectedSuccessFullMessage} />}</span>}</div>
        <div>{props.isMonthlyRevenueSubmitted && <span className="contractCodeStyle"><ul>{props.contractCodeListDisplay}</ul></span>}</div>        
        </div></div>
        <div className = "Button-Container"> 
            { (props.Status === RequestStatus.Success.id || props.Status === RequestStatus.SuccessCr.id) ? continueButton(props) : undefined}
        </div>
    </div>)
}

const continueButton = (props) =>{
    return (
    <Button variant="secondary" onClick={(ev)=>props.onHideHandler()}
                    size="sm" className = "continue-Btn" 
                    style = { (props.Status === RequestStatus.Failed.id || props.Status === RequestStatus.FailedCr.id) ? {backgroundColor : "red"} 
                                : {backgroundColor : 'green'}}>
        {<LabelText tid="continue" />}
    </Button>
)}

const failedBodyMessage = (props) =>{
    return (
        <div className= "Bulk-processing-body">
            <div className = "Status-label">{ (props.Status === RequestStatus.Failed.id || props.Status === RequestStatus.FailedCr.id) ? <LabelText tid={RequestStatus.Failed.value}/> : ""}</div>
            <div className = "failed-Message"> <LabelText tid={props.ErrorMessage}/></div>
            <div className = "Button-Container"> 
            { continueButton(props) }
            </div>
        </div>)
    }

const CustomModal = (props) => (
    <div className="Modal-container">
        <Modal dialogClassName =  "Model-dialogue" show= {props.showModel} backdrop =  "static" 
            keyboard = {true} scrollable = {true}>
            {
                <Modal.Header  closeButton =  {false}
                        className= "Bulk-Modal-header" 
                        style = { (props.Status === RequestStatus.Failed.id || props.Status === RequestStatus.FailedCr.id) ?
                                                {backgroundColor : "red"} : {backgroundColor : '#25336C'}} >
                    <div className = "Image-Container" >
                        <div className = {props.Status === RequestStatus.Inprogress.id ? "img-processing"  : 
                                        (props.Status === RequestStatus.Success.id || props.Status === RequestStatus.SuccessCr.id)?  "CheckSqaure" : 
                                        (props.Status === RequestStatus.Failed.id || props.Status === RequestStatus.FailedCr.id) ? "FailedSqaure" : ""}></div>
                    </div>
                </Modal.Header>
            }
            <Modal.Body style={{overflowx:"hidden", overflowy:"auto"}}>
                { (props.Status === RequestStatus.Failed.id || props.Status === RequestStatus.FailedCr.id) ? failedBodyMessage(props) : 
                                                            inProgressOrSuccessBody(props)}
                    
            </Modal.Body>
        </Modal>
    </div>
);

export default CustomModal;